<template>
  <div>
    <select-single :options="options" @update="update" />

    <div class="text-center mt-4">
      <b-button v-if="gender" @click="goNext" variant="success">Continuer</b-button>
    </div>
  </div>
</template>

<script>
import { BButton } from "bootstrap-vue";
import SelectSingle from "@/components/Select/Single";

export default {
  name: "Gender",
  components: { BButton, SelectSingle },
  data: () => ({
    gender: null,
    options: [
      { id: "female", name: "Femme" },
      { id: "male", name: "Homme" },
    ],
  }),
  methods: {
    update(value) {
      this.gender = value;
    },
    goNext() {
      const { gender } = this;
      this.$emit("success", gender);
    },
  },
};
</script>
